(function () {
  'use strict';
  angular.
  module('gplans.dashboard.controllers').
  directive('ggHeightValidation', ['$compile', function ($compile) {
    return {
      link: function link(scope, element, attributes) {
        element.on("change", function (e) {
          var maxHeight = 100;
          var minHeight = 50;
          var heightUnit = 'inches';
          var locale = attributes.locale;

          if (locale != 'US') {
            maxHeight = 250;
            minHeight = 125;
            heightUnit = 'cm';
          }
          var val = Number(element.val());
          if (val > maxHeight && val != '') {
            alert('Max height is ' + maxHeight + ' ' + heightUnit);
            e.preventDefault();
            element.val(maxHeight);
            element.trigger('change');
          } else
          if (val < minHeight && val != '') {
            alert('Min Height is ' + minHeight + ' ' + heightUnit);
            e.preventDefault();
            element.val(minHeight);
            element.trigger('change');
          }
        });
      } };

  }]);
})();